// EZLynx's Prior Carrier list (auto Policy Info dropdown), scraped 2026-05-20; the home quote's list
// uses the same names. "Other Standard" is the catch-all when no other carrier matches (see
// normalizePriorCarrier in easykey-values.js).
export const EZLYNX_PRIOR_CARRIERS = [
  'Other Standard',
  'Other Non-Standard',
  'No Prior Insurance',
  '1st Auto',
  '21st Century',
  'A.Central',
  'AAA',
  'AARP',
  'Acadia',
  'Acceptance Insurance',
  'Access General',
  'Ace',
  'Acuity',
  'Adirondack Ins Exchange',
  'Aegis',
  'Affirmative',
  'Ag Workers Mutual Auto',
  'AIC',
  'AIG',
  'Alert Auto Insurance Company',
  'Alfa Alliance',
  'Alinsco',
  'Allied Trust Insurance Company',
  'Allied',
  'Allstate',
  'America First',
  'American Commerce',
  'American Family',
  'American Freedom Insurance Company',
  'American National',
  'Amerisure',
  'Amica',
  'AmShield',
  'AmWINS Star',
  'Anchor General',
  'Arrowhead Everest',
  'Arrowhead',
  'ASI Lloyds',
  'ASI Select Auto Insurance Corp',
  'Aspen',
  'Aspire',
  'AssuranceAmerica',
  'Atlantic Mutual',
  'Austin Mutual',
  'Autoone',
  'Auto-Owners',
  'AutoTex',
  'Badger Mutual',
  'Balboa',
  'Bankers',
  'Beacon National',
  'Bear River Mutual',
  'Brethern Mutual',
  'Bristol West',
  'Buckeye',
  'California Casualty',
  'Cameron Mutual',
  'Capital Insurance Group',
  'Capitol Insurance Company',
  'Casualty Underwriters Insurance Company',
  'Celina',
  'Centennial',
  'Central Mutual of OH',
  'Century National',
  'Charter',
  'Chubb',
  'Cincinnati Casualty',
  'Cincinnati Insurance',
  'Citizens',
  'Clearcover',
  'CNA',
  'Colonial Penn',
  'Colorado Casualty',
  'Columbia',
  'Commerce West',
  'Commonwealth',
  'Concord Group Insurance',
  'Connect Banner',
  'Constitutional Casualty',
  'Consumers',
  'Cornerstone',
  'Country Insurance',
  'Countryway Insurance',
  'Countrywide',
  'Cover Insurance',
  'CSE',
  'Cumberland',
  'Dairyland',
  'Deerbrook',
  'Delta Lloyds Insurance Company',
  'Depositors',
  'Direct General',
  'Direct',
  'Discovery',
  'Donegal',
  'Drive',
  'Electric',
  'Elephant Insurance',
  'Embark General',
  'EMC',
  'Empower',
  'Encompass',
  'Encova Exceed',
  'Enumclaw Insurance',
  'Erie',
  'Esurance',
  'Eveready',
  'Explorer',
  'Farm Bureau',
  'Farmers',
  'Federated',
  'Fidelity',
  'Financial Indemnity',
  'Firemans Fund',
  'First Acceptance',
  'First American',
  'First Auto',
  'First Chicago',
  'First Connect',
  'Fitchburg Mutual',
  'Flagship Insurance',
  'Foremost',
  'Founders',
  'Frankenmuth',
  'Fred Loya',
  'Fremont Insurance',
  'GAINSCO Auto Insurance',
  'Gateway',
  'Geico',
  'General Casualty',
  'Germania Insurance',
  'Germantown Mutual',
  'GMAC',
  'Goodville Mutual',
  'Grange Insurance Association',
  'Grange',
  'GRE/Go America',
  'Great American',
  'Grinnell',
  'Guide One',
  'Hallmark Insurance Company',
  'Hanover',
  'Harbor',
  'Harleysville',
  'Hartford OMNI',
  'Hartford',
  'Hastings Mutual',
  'Haulers Insurance Company',
  'Hawkeye Security',
  'HDI',
  'Hochheim Prairie Insurance',
  'Horace Mann',
  'Houston General',
  'IFA',
  'Imperial Casualty',
  'IMT Ins',
  'Indiana Farmers',
  'Indiana',
  'Infinity',
  'Insuremax',
  'Insurequest',
  'Integon',
  'Integrity',
  'Iowa Mutual Insurance Company',
  'Kemper Specialty',
  'Kemper',
  'Kingsway',
  'Legacy - Arizona Auto Ins. Co',
  'LeMars Insurance',
  'Liberty Mutual',
  'Liberty Northwest',
  'Madison Mutual Insurance Company',
  'Maidstone Insurance',
  'MAIF',
  'Main Street America',
  'Mapfre',
  'Markel',
  'Maryland Auto Insurance',
  'Mendakota',
  'Mendota',
  'Merchants Group',
  'Mercury',
  'MetLife',
  'Metropolitan',
  'Michigan Insurance Company',
  'Michigan Millers Mutual Insurance Company',
  'Mid-Continent',
  'Midwestern Indemnity',
  'Mile Auto',
  'MMG Insurance Company',
  'Montgomery',
  'Motor Club Insurance Company',
  'Motorists Mutual',
  'MSA',
  'Mt. Washington',
  'Mutual Benefit',
  'Mutual of Enumclaw',
  'National General',
  'National Lloyds Insurance Company',
  'Nationwide',
  'New York Central Mutual',
  'NJ Manufacturers',
  'NJ Skylands',
  'NLC Insurance Companies',
  'Nodak Mutual',
  'Northern Neck Insurance Company',
  'Northstar',
  'NYAIP',
  'NYCM Standard',
  'Occidental',
  'Ocean Harbor',
  'Ohio Casualty',
  'Ohio Mutual',
  'Omaha P/C',
  'Omni Insurance Co',
  'One Beacon',
  'Oregon Mutual',
  'Palisades',
  'Partners Mutual Insurance',
  'Patriot',
  'Patrons Oxford',
  'Peerless/Montgomery',
  'Pekin',
  'Pemco',
  'Peninsula Insurance Companies',
  'Penn National',
  'Personal Service Insurance',
  'Phoenix Indemnity',
  'Pioneer State Mutual',
  'Plymouth Rock',
  'Preferred Mutual',
  'Proformance',
  'Progressive',
  'Providence Mutual Fire Insurance Company',
  'Prudential',
  'QBE',
  'Quincy Mutual',
  'RAM Mutual Insurance Company',
  'Republic',
  'Response',
  'Rockford Mutual',
  'Rockingham Casualty Company',
  'Royal and Sun Alliance',
  'Safe Auto',
  'Safeco',
  'Safety Insurance Company',
  'Safeway',
  'Sagamore',
  'SECURA',
  'Selective',
  'Sentry Ins',
  'Sheboygan Falls Insurance',
  'Shelter Insurance',
  'Southern County',
  'Southern Mutual',
  'Southern Trust',
  'St. Paul/Travelers',
  'Standard Mutual',
  'Star Casualty',
  'State Auto',
  'State Farm',
  'StillWater',
  'Stonegate',
  'Sublimity Insurance Company',
  'Sun Coast Platinum',
  'Texas Ranger MGA',
  'The General',
  'Titan',
  'Topa',
  'Tower',
  'Travelers',
  'TWFG',
  'Unigard',
  'United Automobile',
  'United Fire and Casualty',
  'United Heritage Property and Casualty Company',
  'United Home',
  'Unitrin',
  'Universal',
  'USAA',
  'Utica National',
  'Victoria',
  'Wadena Insurance Company',
  'Wayne Mutual Insurance Company',
  'West Bend',
  'Western National',
  'Western Reserve Group',
  'Westfield',
  'White Mountains',
  'Wilshire',
  'Wilson Mutual',
  'Wind Haven',
  'Windsor',
  'Wisconsin Mutual',
  'Wolverine Mutual Insurance Company',
  'Workmens Auto Insurance Company',
  'Zurich'
];
